import React from "react";

export function Space({ height = "1rem", width = "1rem" }) {
  return <div style={{ height, width }} />;
}
